/* global fetch */

import Resources from '../helpers/resources';
import { locale } from './locale-utils';

export const SET_LOCALE_DATA = 'SET_LOCALE_DATA';

function setTranslationData() {
    function setLocale(response, dispatch) {
        response.json()
            .then(translations => dispatch({
                type: SET_LOCALE_DATA,
                payload: {
                    translations
                }
            })
            );
    }
    return dispatch => Resources
        .getConfigurationItem('LocalisationCdnBaseUrl')
        .then((linguiCdnBaseUrl) => {
            const localePath = locale();
            let cdnPath = `${linguiCdnBaseUrl}/${localePath}.json`;
            fetch(cdnPath)
                // eslint-disable-next-line consistent-return
                .then((response) => {
                    if (response.ok) {
                        setLocale(response, dispatch);
                    } else {
                        cdnPath = `${linguiCdnBaseUrl}/en-AU.json`;
                        fetch(cdnPath).then(response2 => setLocale(response2, dispatch))
                            // eslint-disable-next-line no-console
                            .catch(error => console.log(`fetching of default locale also failed: ${error}`));
                    }
                })
                // eslint-disable-next-line no-console
                .catch(error => console.log(`fetching json locale failed: ${error}`));
        });
}

export default {
    setTranslationData
};




// WEBPACK FOOTER //
// ./locale/locale-actions.js